import React from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
import { Metric } from "../../../../metric";
var cn = classNames.bind(style);
export var SocialLink = function SocialLink(_ref) {
  var name = _ref.name,
    srcImage = _ref.srcImage,
    url = _ref.url,
    theme = _ref.theme;
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: name,
    events: {
      shortFooterMetric: ['handleClickIcon']
    },
    mode: "click",
    "data-t-id": "components-SocialLink"
  }, /*#__PURE__*/React.createElement("li", {
    className: cn('social-link', "link-theme__".concat(theme)),
    key: name,
    "data-t-id": "components-SocialLink"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": name,
    className: cn('social-link__link', "social-link__link--".concat(name)),
    href: url,
    rel: "nofollow noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u0443\u044E \u0441\u0435\u0442\u044C ".concat(name),
    className: cn('social-link__img', "social-link__img--".concat(name)),
    loading: "lazy",
    src: srcImage
  }))));
};